export default __webpack_public_path__ + "static/media/Vinesh's Resume.988d8b3f.pdf";